import { IAxiosError } from '@/@types/AxiosError';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useToast } from '@/common/hooks/useToast';

import { postDebitNoteFlag } from '../services/postDebitNoteFlag';
import { postFlagDebitNotes } from '../services/postFlagDebitNotes';

export function useFlagDebitNotes(userLogged = false) {
  const { t } = useTranslation('invoicing/requestApprovalReview');
  const { toast } = useToast();

  const {
    mutateAsync: mutatePostFlagDebitNotes,
    isLoading: isLoadingPostFlagDebitNotes,
  } = useMutation({
    mutationFn: postFlagDebitNotes,
    onError: (errorRequest: IAxiosError) => {
      toast.error(
        t('errorOnFlagDebitNotes'),
        errorRequest?.response?.data?.friendlyMessage,
        {
          toastId: 'flag-debit-notes',
        },
      );
    },
  });

  const {
    mutateAsync: mutatePostDebitNoteFlag,
    isLoading: isLoadingPostDebitNoteFlag,
  } = useMutation({
    mutationFn: postDebitNoteFlag,
    onError: (errorRequest: IAxiosError) => {
      toast.error(
        t('errorOnFlagDebitNotes'),
        errorRequest?.response?.data?.friendlyMessage,
        {
          toastId: 'flag-debit-notes',
        },
      );
    },
  });

  return {
    flagDebitNotes: userLogged
      ? mutatePostDebitNoteFlag
      : mutatePostFlagDebitNotes,
    isFlaggingDebitNotes: userLogged
      ? isLoadingPostDebitNoteFlag
      : isLoadingPostFlagDebitNotes,
  };
}
